<template>
  <GmbDataEditionEditForm
      :filterTree="filterTree"
      isCreationMode
      :miscEnumerations="miscEnumerations"
      :organizations="organizations"
      title="Renseignements de l'individu"
      @individuals-edited="
      (individuals) => $emit('individuals-edited', individuals)
    "
  >
    <template #picto>
      <FdText colorTheme4 fa><i class="fas fa-user"/></FdText>
    </template>

    <template #control>
      <b-button
          class="d-flex p-1 justify-content-center align-items-center text-size-reset rounded-1 btn-transparent-danger"
          type="button"
          @click="hide('create-individual')"
      >
        <FdText fa><i class="fas fa-close"/></FdText>
        <FdText class="mx-2" tag="span">Annuler</FdText>
      </b-button>
    </template>
  </GmbDataEditionEditForm>
</template>

<script>
import ModalEventBus from "@/modalEventBus.js";

import FdText from "@/flexdesign/Text";

import GmbDataEditionEditForm from "@/views/Observatory/DataEdition/DataEditionEditForm";

export default {
  name: "GmbDataEditionCreate",

  components: {
    FdText,
    GmbDataEditionEditForm,
  },

  props: {
    filterTree: Object,
    miscEnumerations: Object,
    organizations: Array,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    hide(modalSlug) {
      ModalEventBus.$emit("gmb-close-modal", modalSlug);
    },
  },
};
</script>

<style lang="scss"></style>
